<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ data.sampling.name }}</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="editPacksState" @submit.prevent="saveMixin">
          <v-container fluid grid-list-xl class="pt-0">
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.sampling.packages"
                    :model="packagingsModel"
                    name="packages"
                    label="Select packages"
                    item-text="name"
                    item-value="id"
                    required
                    return-object
                    multiple
                  />
                  <field-messages
                    name="packages"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Packages is a required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Sampling from '@/orm/models/Sampling';
import Packagings from '@/orm/models/Packagings';
import asyncAutocomplete from '@/components/form/asyncAutocomplete';

export default {
  name: 'editPacksPopup',
  props: {
    dialog: Boolean,
    sampling: {
      type: Object,
      default: () => new Sampling(),
    },
  },
  data() {
    return {
      data: {
        sampling: JSON.parse(JSON.stringify(this.sampling)),
      },
      packagingsModel: Packagings,
      editPacksState: {},
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.data.sampling = JSON.parse(JSON.stringify(this.sampling));
      }
    },
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
  },
  methods: {
    close() {
      this.data.sampling = new Sampling();
      this.editPacksState._reset();
      this.dialogLocal = false;
    },
    saveMixin() {
      if (!this.editPacksState.$valid) {
        return;
      }
      this.$emit('update', this.data);
      this.close();
    },
  },
  components: {
    asyncAutocomplete,
  },
};
</script>
